import { render } from "./ReviewsOverview.vue?vue&type=template&id=10c4ac1a&scoped=true&ts=true"
import script from "./ReviewsOverview.vue?vue&type=script&lang=ts"
export * from "./ReviewsOverview.vue?vue&type=script&lang=ts"

import "./ReviewsOverview.vue?vue&type=style&index=0&id=10c4ac1a&scoped=true&lang=scss"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c4ac1a"]])

export default __exports__